import { render, staticRenderFns } from "./colonelpage.vue?vue&type=template&id=0f362a59&scoped=true"
import script from "./colonelpage.vue?vue&type=script&lang=js"
export * from "./colonelpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f362a59",
  null
  
)

export default component.exports